import { Radio, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import React from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setResolution } from "../../Redux/DownloadSlice/downloadSlice";
import SwitchCustom from "../Switches/Switch";
import type { RootState } from "../../Redux/store";
import { usePremiumStatus } from "../../hooks/usePremiumStatus";
import PremiumGateDialog from "../Common/PremiumGateDialog";
import diamond from "../../Assets/Images/icons/diamond.png";

interface ImageDimensionsProps {
  downloadState: RootState["downloadSlice"];
}

const ImageDimensions: React.FC<ImageDimensionsProps> = ({ downloadState }) => {
  const [selectedValue, setSelectedValue] = React.useState(1600);
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(false);
  const [showGateDialog, setShowGateDialog] = React.useState(false);
  const isPremium = usePremiumStatus();

  const dispatch = useDispatch();

  const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isPremium) {
      setShowGateDialog(true);
      return;
    }
    const nextChecked = event.target.checked;
    setChecked(nextChecked);
    dispatch(setResolution(nextChecked ? "0" : String(selectedValue)));
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!checked) {
      const val = parseInt(event.target.value, 10);
      setSelectedValue(val);
      dispatch(setResolution(String(val)));
    }
  };
  useEffect(() => {
    const resStr = String(downloadState?.Resolution ?? "");
    if (resStr === "0") {
      setChecked(true);
      setSelectedValue(1600);
    } else if (resStr === "") {
      setChecked(false);
      setSelectedValue(1600);
    } else {
      const res = parseInt(resStr, 10);
      setChecked(false);
      setSelectedValue(Number.isNaN(res) ? 1600 : res);
    }
  }, [downloadState.Resolution]);
  const controlProps = (item: number) => ({
    checked: !checked && selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": String(item) },
  });

  const maintainResolutionLabel = (
    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {t("DownloadImage.Resolution")}
      {!isPremium && (
        <Tooltip title="Available in Pro plan">
          <img src={diamond} alt="premium" style={{ width: 14, height: 14, marginLeft: 2 }} />
        </Tooltip>
      )}
    </span>
  );

  return (
    <>
      <Card className="bg_grey">
        <Card.Header>
          <Col className="p-1 d-flex justify-content-between">
            <Row className="productSans text_15 d-flex justify-content-center align-items-center">
              {maintainResolutionLabel}
            </Row>
            <Row className="p-0 m-0">
              <FormGroup sx={{ p: 0, m: 0 }}>
                <FormControlLabel
                  label=""
                  control={
                    <SwitchCustom
                      checked={checked}
                      onChange={handleChangeSwitch}
                      sx={{ p: 0, m: 0 }}
                    />
                  }
                />
              </FormGroup>
            </Row>
          </Col>
        </Card.Header>
        <Card.Body className="py-0">
          <Col className="p-1 d-flex justify-content-between align-items-center">
            <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
              {"1600px"}
            </Row>
            <Row className="m-0 d-flex justify-content-center align-items-center">
              <Radio
                disabled={checked}
                {...controlProps(1600)}
                sx={{
                  "&.Mui-checked": {
                    color: "#F35B6A",
                  },
                }}
              />
            </Row>
          </Col>

          <Col className="border-top p-1 d-flex justify-content-between align-items-center">
            <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
              {"1024px"}
            </Row>
            <Row className="m-0 d-flex justify-content-center align-items-center">
              <Radio
                disabled={checked}
                {...controlProps(1024)}
                sx={{
                  "&.Mui-checked": {
                    color: "#F35B6A",
                  },
                }}
              />
            </Row>
          </Col>
          <Col
            className="border-top p-1 d-flex justify-content-between align-items-center"
          >
            <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
              {"960px"}
            </Row>
            <Row className="m-0 d-flex justify-content-center align-items-center">
              <Radio
                disabled={checked}
                {...controlProps(960)}
                sx={{
                  "&.Mui-checked": {
                    color: "#F35B6A",
                  },
                }}
              />
            </Row>
          </Col>
        </Card.Body>
      </Card>
      <PremiumGateDialog
        open={showGateDialog}
        onClose={() => setShowGateDialog(false)}
        title="Original Resolution — Pro Feature"
        message="Maintaining original image resolution is available in the Pro plan. Upgrade to save your watermarked images at full quality."
      />
    </>
  );
};

export default ImageDimensions;
